import type { ICatalog } from '@platform/core/types';

/**
 * Головні таблиці встановлених модулів, у яких є записи (за лічильниками каталогу), у порядку каталогу; `modules` — лише ці модулі.
 * Спільний набір типів для «Моєї роботи» Головної й зведень робочого простору: однакові аргументи — один запит у кеші RTK Query.
 */
export function mainRecordTypes(catalog: ICatalog | undefined, modules?: readonly string[]): string[] {
  return (catalog?.modules ?? [])
    .filter((m) => m.installed && (!modules || modules.includes(m.key)))
    .flatMap((m) => m.recordTypes.filter((r) => r.main && r.recordCount > 0).map((r) => r.key));
}
